import React from 'react'
import QuestionnaireArea from "./QuestionnaireArea"

export default class extends React.Component {
  static defaultProps = {
    school: {},
    locale: 'fi',
    code: 'NOTVALID'
  };

  render() {
    return (
      <div className="header">
        <h1>
          {I18N._("Welcome to the Koulun hyvinvointiprofiili -questionnaire", { locale: this.props.locale })}
        </h1>

        <p>
          {I18N._("This questionnaire aims to evaluate school well-being. The results will be used for improving the well-being in your school. In addition, the data may be used for scientific research purposes. No one will be able to identify who answered what.",
            { locale: this.props.locale })}
        </p>

        <p>
          {I18N._("Please, answer all questions. Thank you!", { locale: this.props.locale })}
        </p>

        <p>
          {I18N._("Your school:", { locale: this.props.locale })} {this.props.school.name}
          <br />
          {I18N._("Your code:", { locale: this.props.locale })} <strong>{this.props.code}</strong>
          <br />
          <small>
            {I18N._("If you don't fill out all the questions now, you can use the code to continue later.", { locale: this.props.locale })}
          </small>
        </p>

        {this.props.greeting_text && <p>{this.props.greeting_text}</p>}

      </div>
    )
  }
}